var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeZoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 31.997 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1373.427-991.924h2.249c.193.026.386.054.58.076a15.689,15.689,0,0,1,7.719,2.995,15.768,15.768,0,0,1,6.32,10.138c.1.57.167,1.148.249,1.722v2.124c-.047.37-.088.74-.141,1.109a15.488,15.488,0,0,1-4.889,9.449,15.541,15.541,0,0,1-15.09,3.821,15.262,15.262,0,0,1-9.065-6.42,15.539,15.539,0,0,1-2.514-12.005,15.592,15.592,0,0,1,5.881-9.633,15.407,15.407,0,0,1,7.043-3.133C-1374.535-991.776-1373.98-991.844-1373.427-991.924Zm.311,5.318c-.166.014-.333.018-.5.043a1.029,1.029,0,0,0-.875.925c-.091,1.423-.171,2.846-.254,4.269-.092,1.579-.146,3.161-.286,4.736a2.748,2.748,0,0,0,1.022,2.529c1.783,1.518,3.553,3.053,5.285,4.628.786.715,1.405.812,2.191-.071a1.114,1.114,0,0,0,.057-1.657q-2.012-2.326-4.027-4.65a3.136,3.136,0,0,1-.793-1.893c-.139-2.3-.261-4.592-.391-6.888-.012-.208-.039-.415-.047-.623C-1371.771-986.256-1372.121-986.6-1373.116-986.606Z",
    transform: "translate(1388.307 991.924)",
    fill: "#734bd1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeZoneIcon);
export default __webpack_public_path__ + "static/media/timeZoneIcon.fdceccc953616571c7238290fab205e5.svg";
export { ForwardRef as ReactComponent };